const MONTH_NAMES = [
  'Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie',
  'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie',
];

const DAY_NAMES = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'];

/** Format date as dd/mm/yyyy — e.g. "25/03/2026" */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}

/** Format date with day name — e.g. "Miercuri, 25/03/2026" */
export function formatDateWithDay(iso: string): string {
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${DAY_NAMES[d.getDay()]}, ${dd}/${mm}/${d.getFullYear()}`;
}

/** Format date from parts — e.g. "25/03/2026" */
export function formatDateParts(year: number, month: number, day: number): string {
  const dd = String(day).padStart(2, '0');
  const mm = String(month).padStart(2, '0');
  return `${dd}/${mm}/${year}`;
}

/** Format date with day name from parts — e.g. "Miercuri, 25/03/2026" */
export function formatDateWithDayParts(year: number, month: number, day: number): string {
  const date = new Date(year, month - 1, day);
  const dd = String(day).padStart(2, '0');
  const mm = String(month).padStart(2, '0');
  return `${DAY_NAMES[date.getDay()]}, ${dd}/${mm}/${year}`;
}

/** Format time as HH:MM — e.g. "19:00" */
export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
}

/** Get month name in Romanian */
export function getMonthName(month: number): string {
  return MONTH_NAMES[month];
}

/** Convert ISO to datetime-local input value */
export function toLocalDatetime(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60000);
  return local.toISOString().slice(0, 16);
}
